import {CommonMessages} from '../common.messages';

export const PanelAccountsAddMessages = {
    GetClientFailed: {
        key: 'GetClientFailed',
        message: 'Error while communication with the server. Unable to get client.'
    },
    GetClientNotFound: {
        key: 'GetClientNotFound',
        message: 'Error while communication with the server. Unable to find client.'
    },
    ...CommonMessages
};
